import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ContactService} from 'src/app/modules/services/contact/contact.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ConditionUtilisationService} from '../../../modules/services/condtionutilisation/condition-utilisation.service';

@Component({
    selector: 'app-contact-terminologie',
    templateUrl: './contact-terminologie.component.html',
    styleUrls: ['./contact-terminologie.component.css']
})
export class ContactTerminologieComponent implements OnInit {
    public seqNo = null;
    public item: any;
    public current_lang = this.translate.getDefaultLang();

    @ViewChild('frContainer', {static: true}) frContainer: ElementRef;


    constructor(private route: ActivatedRoute,
                private contactService: ContactService,
                private conditionUtilisationService: ConditionUtilisationService,
                private translate: AppTranslateService,
                private translateS: TranslateService
    ) {

    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.seqNo = params.id;
            this.loadcard();
        });
        this.translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
            this.loadcard();

        });
    }


    loadcard() {

        this.conditionUtilisationService.getPtSingleScreenBySeqNo(this.seqNo).subscribe(payload => {
            this.item = payload;
            if (this.current_lang == 'ar') {
                this.frContainer.nativeElement.innerHTML = this.item?.cont2;
            }
            if (this.current_lang == 'fr') {
                this.frContainer.nativeElement.innerHTML = this.item?.cont1;
            }
            if (this.current_lang == 'en') {
                this.frContainer.nativeElement.innerHTML = this.item?.contEn;
            }
        });
    }

// loadcard(){
//   {

//     this.contactService.loadcard(this.id)
//     .subscribe (response => {

//       this.item = response['payload'];
//       console.log("response",response)
//      console.log("hamza",this.item)

//       });
//   }

// }

    getlangue() {

        return this.translate.getDefaultLang() == 'ar';
    }


}
